var React = require('react');

function IconBin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 3V5H21V7H3V5H9V3H15ZM5 20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H17L17.001 20H7V8H5V20ZM9 10H11V18H9V10ZM15 10H13V18H15V10Z","fill":"#00121A"}));
}

IconBin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconBin;

IconBin.default = IconBin;
